
import { Component, Vue } from 'vue-property-decorator'
import Swiper, { SwiperOptions } from 'swiper'

@Component({})
export default class HighlightCarousel extends Vue {
  highlightSwiper: Swiper | null = null

  smallSwiper: Swiper | null = null

  highlightSwiperOptions: SwiperOptions = {
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 750,
    on: {
      slideChange: this.onSlideChangeHighlight
    }
  }

  smallSwiperOptions: SwiperOptions = {
    spaceBetween: 20,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    on: {
      slideChange: this.onSlideChangeSmall
    }
  }

  onSlideChangeSmall(): void {
    if (this.highlightSwiper && this.smallSwiper) this.highlightSwiper.slideTo(this.smallSwiper.activeIndex)
  }

  onSlideChangeHighlight(): void {
    if (this.smallSwiper && this.highlightSwiper) this.smallSwiper.slideTo(this.highlightSwiper.activeIndex)
  }

  mounted() {
    this.$nextTick(() => {
      this.highlightSwiper = (this.$refs.highlightSwiper as any).$swiper as Swiper
      this.smallSwiper = (this.$refs.smallSwiper as any).$swiper as Swiper
    })
  }
}
